import React from 'react';
import { Github, Linkedin, Mail, Phone, MapPin, Download } from 'lucide-react';
import { Button } from './ui/button';
import { portfolioData } from '../mock';

const Hero = () => {
  const { personal } = portfolioData;

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 pt-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-20">
        <div className="max-w-4xl mx-auto text-center">
          {/* Animated greeting */}
          <div className="inline-block mb-4 sm:mb-6">
            <span className="text-cyan-400 text-sm sm:text-base font-mono bg-cyan-400/10 px-4 py-2 rounded-full border border-cyan-400/30">
              Hello, I'm
            </span>
          </div>

          {/* Name */}
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold text-white mb-4 sm:mb-6 tracking-tight">
            {personal.name}
          </h1>

          {/* Title */}
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-cyan-400 mb-4 sm:mb-6">
            {personal.title}
          </h2>

          {/* Tagline */}
          <p className="text-lg sm:text-xl md:text-2xl text-gray-300 mb-6 sm:mb-8 font-light">
            {personal.tagline}
          </p>

          {/* Summary */}
          <p className="text-base sm:text-lg text-gray-400 mb-8 sm:mb-12 max-w-3xl mx-auto leading-relaxed">
            {personal.summary}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
            <Button
              size="lg"
              className="bg-cyan-500 hover:bg-cyan-600 text-white px-8 py-6 text-base sm:text-lg w-full sm:w-auto transition-all duration-300 hover:scale-105"
              onClick={() => document.getElementById('projects').scrollIntoView({ behavior: 'smooth' })}
            >
              View Projects
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="border-2 border-cyan-400 text-cyan-400 hover:bg-cyan-400 hover:text-slate-900 px-8 py-6 text-base sm:text-lg w-full sm:w-auto transition-all duration-300 hover:scale-105"
              onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            >
              Get In Touch
            </Button>
          </div>

          {/* Quick Contact Info */}
          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-gray-400 text-sm sm:text-base mb-6">
            <div className="flex items-center gap-2">
              <MapPin size={18} className="text-cyan-400" />
              <span>{personal.location}</span>
            </div>
            <div className="flex items-center gap-2">
              <Mail size={18} className="text-cyan-400" />
              <a href={`mailto:${personal.email}`} className="hover:text-cyan-400 transition-colors">
                {personal.email}
              </a>
            </div>
          </div>

          {/* Scroll indicator */}
          <div className="flex justify-center animate-bounce">
            <div className="w-6 h-10 border-2 border-gray-400 rounded-full flex items-start justify-center p-2">
              <div className="w-1 h-3 bg-cyan-400 rounded-full"></div>
            </div>
          </div>
        </div>
      </div>

    </section>
  );
};

export default Hero;